export const heroData = {
  title: 'Elegant Balinese Cats',
  subtitle: 'Raising healthy, happy, and well-socialized Balinese cats with love and care',
  primaryButton: {
    text: 'View Available Kittens',
    href: '/kittens'
  },
  secondaryButton: {
    text: 'Learn About Us',
    href: '/about'
  },
  image: '/images/adults2.jpeg'
};
